import { RootState } from '@reducers';

export const selectPolicy = (state: RootState) => state.userDashboardRouteReducer.policyReducer;
